import zeroBeesLogo from "src/assets/images/ZeroBees_logo_new.svg";

const IntroSection = () => {
  return (
    <section className="pt-5">
      <div className="w-100 mx-auto  d-flex flex-column justify-content-center position-relative text-center">
        <a href="https://www.zerobees.com/">
          {" "}
          <img
            style={{ width: 160 }}
            src={zeroBeesLogo}
            className="mb-2 mx-auto"
            alt="ZeroBees Logo"
          />
        </a>
        <p style={{ fontSize: "32px" }} className="font-bold  text-info mb-0 ">
          Welcome to the
        </p>
        <h1
          style={{
            fontSize: "48px",
          }}
          className="text-center mb-4"
        >
          Business Impact Tracker
        </h1>
        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            maxWidth: "600px",
            margin: "auto",
          }}
          className="text-center mb-1"
        >
          The Business Impact Tracker enables SMEs to assess their
          sustainability maturity in a standardised format, comparable with
          consensus ESG ratings.
        </p>
        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            maxWidth: "600px",
            margin: "auto",
          }}
          className="text-center mb-3"
        >
          It is a transparent set of 26 questions across Environment, Employees,
          Community & Supply Chains and Governance
        </p>
      </div>
    </section>
  );
};

export default IntroSection;
